.trigger {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1-5);
  height: var(--control-sm);
  padding: 0 var(--space-2) 0 var(--space-3);
  border: var(--border-width) solid var(--color-border-strong);
  border-radius: var(--radius-full);
  background: var(--color-surface-raised);
  color: var(--color-text);
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
  white-space: nowrap;
  cursor: pointer;
  transition: background-color var(--duration-fast) var(--ease-standard);
}

.trigger:hover {
  background: var(--color-surface-hover);
}

.trigger[data-state="open"] {
  background: var(--color-surface-pressed);
}

.chevron {
  display: inline-flex;
  color: var(--color-text-muted);
}

.short {
  display: none;
  font-variant-numeric: tabular-nums;
  letter-spacing: var(--tracking-caps);
}

/* Narrow screens: the short form (e.g. "PL") keeps the header uncluttered. */
@media (max-width: 599.98px) {
  .full {
    display: none;
  }

  .short {
    display: inline;
  }
}

/* Wider than its pill-shaped trigger (attribute selector outranks the shared list width). */
.content[data-side] {
  width: auto;
  min-width: 180px;
}
